import { useState } from "react";
import NavBar from "./components/NavBar";
import { makeStyles } from "@material-ui/core/styles";
import Mapa from "./screens/Mapa";
import Hoy from "./screens/Hoy";
import Graficas from "./screens/Graficas";
import Vacunas from "./screens/Vacunas";
import Info from "./screens/Info";
import Privacy from "./screens/Privacy";
import PrivacyDialog from "./components/PrivacyDialog";
import { AppContext } from "./AppContext";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

const useStyles = makeStyles({
  screen: {
    flexGrow: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyItems: "center",
    overflowX: "hidden",
  },
});

const App = () => {
  const classes = useStyles();
  const [mapData, setMapData] = useState();
  const [today, setToday] = useState(null);
  const [newCasesPieData, setNewCasesPieData] = useState(null);
  const [newDeathsPieData, setNewDeathsPieData] = useState(null);
  const [graphs, setGraphs] = useState(null);
  const [vaccines, setVaccines] = useState(null);
  const [info, setInfo] = useState(null);

  window.addEventListener("orientationchange", () => {
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 500);
  });

  return (
    <AppContext.Provider
      value={{
        mapData,
        setMapData,
        today,
        setToday,
        newCasesPieData,
        setNewCasesPieData,
        newDeathsPieData,
        setNewDeathsPieData,
        graphs,
        setGraphs,
        vaccines,
        setVaccines,
        info,
        setInfo,
      }}
    >
      <Router>
        <div className={classes.screen}>
          <Switch>
            <Route exact path="/" component={Mapa} />
            <Route exact path="/hoy" component={Hoy} />
            <Route exact path="/graficas" component={Graficas} />
            <Route exact path="/vacunas" component={Vacunas} />
            <Route exact path="/info" component={Info} />
            <Route exact path="/privacy" component={Privacy} />
            <Route path="/">
              <Redirect to="/" />
            </Route>
          </Switch>
        </div>
        <NavBar />
        {navigator.userAgent.toLowerCase().indexOf("android") > -1 &&
          navigator.userAgent.toLowerCase().indexOf("version") > -1 && (
            <PrivacyDialog />
          )}
      </Router>
    </AppContext.Provider>
  );
};

export default App;
